import { ExtraData } from '@models/extra-data.model';
import * as fromActions from '../actions/extraData.action';

export const initialState: ExtraData = {
    tipoMatricula: [],
    tipoArancel: [],
    especialidades: {
        Medicina: [],
        Odontologia: [],
        Psicologia: [],
        Kinesiologia: [],
        Fisioterapia: [],
        Bioquimica: []
    },
    provincia: [],
    tipoDocumento: [],
    sexo: [],
    parentesco: [],
    modoIngreso: [],
    tipoArchivo: [],
    tipoAtencion: [],
    lugarAtencion: [],
    codFinalizacionTratamiento: [],
    tipoPrestacion: [],
    codigoNombreModel: []
};

export function extraDataReducer(
    state = initialState,
    action: fromActions.extraDataActions
): ExtraData {

    switch (action.type) {

        case fromActions.SETEXTRADATA:
            return action.datosExtra;

        case fromActions.UNSETEXTRADATA:
            return initialState;

        default:
            return state;
    }
}
